import {
    ArrowLeftOutlined,
    DeleteOutlined,
    DownloadOutlined,
    EditOutlined,
    LockOutlined,
    FileExcelOutlined,
    InboxOutlined,
    ReloadOutlined,
    UploadOutlined,
    SaveOutlined,
    SearchOutlined,
    SendOutlined
} from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Input, InputNumber, Modal, Row, Select, Space, Tabs } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import Dropzone from 'react-dropzone';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ContentHeader } from '../../components';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { Links } from '../../helpers/Links';
import { formatVND, validateMessages } from '../../helpers/common';
import { ChiTietLuongPhuCapItem, LuongPhuCapInfo } from '../../models/luong/LuongPhuCapModel';
import TableChiTietLuongPhuCap from '../../modules/salary/TableChiTietLuongPhuCap';
import {
    chiTietLuongPhuCap,
    duyetLuongPhuCap,
    importFileLuongPhuCap,
    layDsBangLuongPhuCapTamUngTheoNam,
    layThongTinBangLuongPhuCap,
    luuDieuChinhChiTietLuongPhuCap,
    luuLuongPhuCap,
    taiDuLieuLuongPhuCap,
    xoaBangLuongPhuCap,
    xuatExcelLuongPhuCap
} from '../../services/luong';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';

const ChiTietLuongPhuCap = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [formCapNhat] = Form.useForm();

    const [idBangLuongPhuCap, setIdBangLuongPhuCap] = useState<number>(0);
    const [luongPhuCap, setLuongPhuCap] = useState<LuongPhuCapInfo | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [tuKhoa, setTuKhoa] = useState<string>('');
    const [isShowModalDuyet, setIsShowModalDuyet] = useState<boolean>(false);
    const [isShowModalXoa, setIsShowModalXoa] = useState<boolean>(false);
    const [isShowModalCapNhat, setIsShowModalCapNhat] = useState<boolean>(false);
    const [isShowImportModal, setIsShowImportModal] = useState<boolean>(false);
    const [fileUpload, setFileUpload] = useState<File | null>(null);
    const [ghiChu, setGhiChu] = useState<string>('');
    const [reload, setReload] = useState<boolean>(false);

    // State cho các tham số cấu hình đợt lương phụ cấp
    const [soCongAnCa, setSoCongAnCa] = useState<number | null>(null);
    const [soCongCTP, setSoCongCTP] = useState<number | null>(null);
    const [idLuongTamUng, setIdLuongTamUng] = useState<number | null>(null);
    const [namTamUng, setNamTamUng] = useState<number>(dayjs().year());
    const [dsTamUng, setDsTamUng] = useState<Array<{ id: number; tenKyLuong: string }>>([]);

    const [danhSachNLD, setDanhSachNLD] = useState<ChiTietLuongPhuCapItem[]>([]);
    const [danhSachChiTiet, setDanhSachChiTiet] = useState<ChiTietLuongPhuCapItem[]>([]);

    // State cho chế độ điều chỉnh
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [changedRowIds, setChangedRowIds] = useState<Set<number>>(new Set());

    const setChiTiet = (data: ChiTietLuongPhuCapItem[]) => {
        const mappedData = (data ?? []).map((item) => ({
            ...item,
            dinhMucCongTac: item.dinhMucCongTac !== undefined && item.dinhMucCongTac !== null
                ? item.dinhMucCongTac
                : (item.mucKhoanCongTac && item.mucKhoanCongTac > 0 ? item.mucKhoanCongTac : 0)
        }));
        setDanhSachChiTiet(mappedData);
        setDanhSachNLD(mappedData);
    };

    const fetchDsTamUng = async (nam: number) => {
        try {
            const res = await layDsBangLuongPhuCapTamUngTheoNam(nam);
            setDsTamUng(res ?? []);
        } catch (e) {
            setDsTamUng([]);
        }
    };

    const layThongTin = async (id: number) => {
        dispatch(showLoadingScreen());
        try {
            const info: LuongPhuCapInfo = await layThongTinBangLuongPhuCap(id);
            setLuongPhuCap(info);
            setGhiChu(info?.ghiChu ?? '');
            setSoCongAnCa(info?.soCongAnCa ?? null);
            setSoCongCTP(info?.soCongCTP ?? null);
            setIdLuongTamUng(info?.idLuongTamUng ?? null);

            if (info?.thangNam) {
                const year = dayjs(info.thangNam).year();
                setNamTamUng(year);
                if (info.loai === 0) {
                    fetchDsTamUng(year);
                }
            }

            const chiTiet = await chiTietLuongPhuCap(id);
            setChiTiet(chiTiet ?? []);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const onMoModalCapNhat = () => {
        const year = luongPhuCap?.thangNam ? dayjs(luongPhuCap.thangNam).year() : dayjs().year();
        setNamTamUng(year);

        formCapNhat.setFieldsValue({
            soCongAnCa: soCongAnCa,
            soCongCTP: soCongCTP,
            namTamUng: year ? dayjs().year(year) : dayjs(),
            idLuongTamUng: idLuongTamUng,
        });

        if (luongPhuCap?.loai === 0) {
            fetchDsTamUng(year);
        }

        setIsShowModalCapNhat(true);
    };

    const onFinishCapNhat = async (values: any) => {
        dispatch(showLoadingScreen());
        try {
            const newSoCongAnCa = values.soCongAnCa ?? null;
            const newSoCongCTP = values.soCongCTP ?? null;
            const newIdLuongTamUng = values.idLuongTamUng ?? null;

            setSoCongAnCa(newSoCongAnCa);
            setSoCongCTP(newSoCongCTP);
            setIdLuongTamUng(newIdLuongTamUng);

            // Lưu thông tin tham số đợt lương
            await luuLuongPhuCap({
                id: idBangLuongPhuCap,
                ghiChu,
                soCongAnCa: newSoCongAnCa,
                soCongCTP: newSoCongCTP,
                idLuongTamUng: newIdLuongTamUng,
                chiTiet: danhSachChiTiet
            });

            // Tải lại dữ liệu lương chi tiết theo tham số mới
            const freshData = await taiDuLieuLuongPhuCap(idBangLuongPhuCap);
            setChiTiet(freshData ?? []);

            // Lấy lại thông tin header đợt lương
            const updatedInfo = await layThongTinBangLuongPhuCap(idBangLuongPhuCap);
            setLuongPhuCap(updatedInfo);

            toast.success('Cập nhật thông tin đợt phụ cấp thành công');
            setIsShowModalCapNhat(false);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleTinhLuong = async () => {
        dispatch(showLoadingScreen());
        try {
            await luuLuongPhuCap({
                id: idBangLuongPhuCap,
                ghiChu,
                soCongAnCa,
                soCongCTP,
                idLuongTamUng,
                chiTiet: danhSachChiTiet
            });
            const data = await taiDuLieuLuongPhuCap(idBangLuongPhuCap);
            setChiTiet(data ?? []);
            toast.success('Tính phụ cấp thành công');
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleImportExcel = async () => {
        if (!fileUpload) {
            toast.warning('Vui lòng chọn file Excel để import');
            return;
        }
        dispatch(showLoadingScreen());
        try {
            const rs = await importFileLuongPhuCap(idBangLuongPhuCap, fileUpload);
            setChiTiet(rs ?? []);
            setIsShowImportModal(false);
            setFileUpload(null);
            toast.success('Import phụ cấp thành công');
        } catch (e: any) {
            toast.error(e?.message || e?.toString().replace('Error: ', '') || 'Import phụ cấp không thành công');
        }
        dispatch(hideLoadingScreen());
    };

    const handleLuu = async () => {
        dispatch(showLoadingScreen());
        try {
            await luuLuongPhuCap({
                id: idBangLuongPhuCap,
                ghiChu,
                soCongAnCa,
                soCongCTP,
                idLuongTamUng,
                chiTiet: danhSachChiTiet
            });
            toast.success('Lưu phụ cấp thành công');
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleDuyet = async () => {
        dispatch(showLoadingScreen());
        try {
            await duyetLuongPhuCap(idBangLuongPhuCap);
            toast.success('Xác nhận phụ cấp thành công');
            setReload(true);
            setIsShowModalDuyet(false);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleXoa = async () => {
        dispatch(showLoadingScreen());
        try {
            await xoaBangLuongPhuCap(idBangLuongPhuCap);
            toast.success('Xóa bảng phụ cấp thành công');
            navigate(Links.Luong.DanhSachLuongPhuCap);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleXuatExcel = async () => {
        if (!idBangLuongPhuCap) {
            toast.warning('Không tìm thấy thông tin phụ cấp');
            return;
        }
        dispatch(showLoadingScreen());
        try {
            const response = await xuatExcelLuongPhuCap(idBangLuongPhuCap);
            const fileName = `${luongPhuCap?.tenKyLuong || 'BangPhuCap'}.xlsx`;
            const link = document.createElement('a');
            link.download = fileName;
            const blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (err: any) {
            toast.error('Xuất file Excel không thành công. Vui lòng thử lại');
        } finally {
            dispatch(hideLoadingScreen());
        }
    };

    // Xử lý thay đổi giá trị tại 1 ô trong bảng khi đang chế độ điều chỉnh
    const onChangeItem = (index: number, field: string, newValue: number) => {
        const updatedList = [...danhSachNLD];
        const row = { ...updatedList[index] };

        // Đảm bảo có định mức CTP gốc để có thể phục hồi khi số công >= 50%
        if (row.dinhMucCongTac === undefined || row.dinhMucCongTac === null) {
            row.dinhMucCongTac = (row.mucKhoanCongTac && row.mucKhoanCongTac > 0) ? row.mucKhoanCongTac : 0;
        }

        const nguongCongCTP = (luongPhuCap?.congThang ?? 22) * 0.5;

        switch (field) {
            case 'soNgayCongAnCa':
                row.soNgayCongAnCa = newValue;
                break;

            case 'soNgayCongCTP':
                row.soNgayCongCTP = newValue;
                // Nếu sửa số công CTP: nếu >= 50% thì lấy 100% định mức CTP, nếu < 50% thì = 0
                if (newValue >= nguongCongCTP) {
                    row.mucKhoanCongTac = row.dinhMucCongTac ?? 0;
                } else {
                    row.mucKhoanCongTac = 0;
                }
                break;

            case 'mucKhoanDienThoai':
                row.mucKhoanDienThoai = newValue;
                break;

            case 'mucKhoanCongTac':
                // Nếu người dùng trực tiếp sửa mức khoán công tác:
                if (newValue > 0) {
                    row.dinhMucCongTac = newValue;
                }
                if ((row.soNgayCongCTP ?? 0) >= nguongCongCTP) {
                    row.mucKhoanCongTac = newValue;
                } else {
                    row.mucKhoanCongTac = 0;
                }
                break;
        }

        // Thành tiền ăn ca
        row.thanhTienAnCa = (row.soNgayCongAnCa ?? 0) * (row.mucChiTienAnCa ?? 0);

        // Tổng cộng được nhận
        row.tongCongDuocNhan =
            (row.thanhTienAnCa ?? 0) +
            (row.mucKhoanDienThoai ?? 0) +
            (row.mucKhoanCongTac ?? 0);

        // Còn được nhận
        row.soTienConDuocNhan =
            (row.tongCongDuocNhan ?? 0) -
            (row.soTienDaUng ?? 0);

        updatedList[index] = row;
        setDanhSachNLD(updatedList);

        // Sync với danhSachChiTiet
        const fullList = [...danhSachChiTiet];
        const chiTietIndex = fullList.findIndex(
            x => (x.id && x.id === row.id) || (x.idNhanVien && x.idNhanVien === row.idNhanVien)
        );

        if (chiTietIndex >= 0) {
            fullList[chiTietIndex] = row;
            setDanhSachChiTiet(fullList);
        }

        const rowKey = row.id || row.idNhanVien || index;
        setChangedRowIds(prev => {
            const newSet = new Set(prev);
            newSet.add(rowKey);
            return newSet;
        });
    };

    // Lưu điều chỉnh chỉ gửi các row đã thay đổi
    const handleLuuDieuChinh = async () => {
        if (changedRowIds.size === 0) {
            toast.warning('Không có dữ liệu thay đổi!');
            return;
        }

        dispatch(showLoadingScreen());
        try {
            const changedItems = danhSachChiTiet
                .filter(x => changedRowIds.has(x.id) || changedRowIds.has(x.idNhanVien))
                .map(x => ({
                    id: x.id,
                    soNgayCongAnCa: x.soNgayCongAnCa,
                    soNgayCongCTP: x.soNgayCongCTP,
                    mucChiTienAnCa: x.mucChiTienAnCa,
                    thanhTienAnCa: x.thanhTienAnCa,
                    mucKhoanDienThoai: x.mucKhoanDienThoai,
                    mucKhoanCongTac: x.mucKhoanCongTac,
                    tongCongDuocNhan: x.tongCongDuocNhan,
                    soTienDaUng: x.soTienDaUng,
                    soTienConDuocNhan: x.soTienConDuocNhan,
                    ghiChu: x.ghiChu,
                }));

            await luuDieuChinhChiTietLuongPhuCap({ items: changedItems });
            toast.success(`Lưu điều chỉnh thành công (${changedItems.length} dòng)`);
            setChangedRowIds(new Set());
            setIsEdit(false);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const search = () => {
        const kw = (tuKhoa || '').toLowerCase();
        setDanhSachNLD(
            danhSachChiTiet.filter(
                (x) =>
                    kw.length === 0 ||
                    (x.hoTen ?? '').toLowerCase().includes(kw) ||
                    (x.ma ?? '').toLowerCase().includes(kw) ||
                    (x.tenDonVi ?? '').toLowerCase().includes(kw)
            )
        );
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const id = urlParams.get('id');
        if (id) {
            setIdBangLuongPhuCap(Number(id));
            layThongTin(Number(id));
        }
    }, [location.search]);

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const id = urlParams.get('id');
        if (reload && Number(id) > 0) {
            setReload(false);
            layThongTin(Number(id));
        }
    }, [reload]);

    const isDaDuyet = (luongPhuCap?.trangThai ?? 0) === 1;
    const coDuLieuDaLuu = danhSachChiTiet.length > 0 && danhSachChiTiet.some(x => x.id > 0);
    const coTheDieuChinh = !isDaDuyet && coDuLieuDaLuu;

    // Tổng hợp số liệu
    const soLaoDong = danhSachChiTiet.length;
    const tongDuocNhan = danhSachChiTiet.reduce((s, x) => s + (x.tongCongDuocNhan ?? 0), 0);
    const tongDaUng = danhSachChiTiet.reduce((s, x) => s + (x.soTienDaUng ?? 0), 0);
    const tongConDuocNhan = danhSachChiTiet.reduce((s, x) => s + (x.soTienConDuocNhan ?? 0), 0);

    const isTamUng = luongPhuCap?.loai === 1;

    return (
        <section>
            <ContentHeader
                title={luongPhuCap?.tenKyLuong ?? ""}
            />

            {/* Thanh công cụ tìm kiếm và nút thao tác */}
            <Row className="form-group" gutter={8}>
                <Col xs={22} sm={14} md={8}>
                    <Input
                        prefix={<SearchOutlined />}
                        placeholder="Nhập tên, mã nhân viên, đơn vị"
                        value={tuKhoa}
                        onChange={(e) => setTuKhoa(e.target.value)}
                        onKeyPress={(e) => { if (e.key === 'Enter') search(); }}
                    />
                </Col>
                <Col xs={2} sm={2} md={0}>
                    <Button type="primary" icon={<SearchOutlined />} onClick={search} />
                </Col>
                <Col xs={0} sm={0} md={4}>
                    <Button type="primary" icon={<SearchOutlined />} onClick={search}>
                        Tìm kiếm
                    </Button>
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <Space className="float-right">
                        <Button type="default" icon={<ArrowLeftOutlined />} onClick={() => { navigate(Links.Luong.DanhSachLuongPhuCap); }}>
                            Quay lại
                        </Button>
                        <Button
                            type="primary"
                            icon={<DownloadOutlined />}
                            className="hrm-btn hrm-btn-success"
                            onClick={handleXuatExcel}
                        >
                            Xuất excel
                        </Button>
                        {!isDaDuyet && (
                            <Button
                                type="primary"
                                icon={<UploadOutlined />}
                                className="hrm-btn hrm-btn-primary"
                                onClick={() => setIsShowImportModal(true)}
                            >
                                Import excel
                            </Button>
                        )}
                        {!isDaDuyet && (
                            <Button
                                danger
                                type="primary"
                                icon={<DeleteOutlined />}
                                onClick={() => setIsShowModalXoa(true)}
                            >
                                Xóa dữ liệu
                            </Button>
                        )}
                        {!isDaDuyet && (
                            <Button
                                type="primary"
                                icon={<EditOutlined />}
                                onClick={onMoModalCapNhat}
                            >
                                Điều chỉnh thông tin
                            </Button>
                        )}
                        {!isDaDuyet && (
                            <Button
                                type="primary"
                                icon={<DownloadOutlined />}
                                onClick={handleTinhLuong}
                            >
                                Tính phụ cấp
                            </Button>
                        )}
                        {!isDaDuyet && (
                            <Button
                                type="primary"
                                icon={<SendOutlined />}
                                onClick={() => setIsShowModalDuyet(true)}
                            >
                                Xác nhận
                            </Button>
                        )}
                        {!isDaDuyet && (
                            <Button
                                className="hrm-btn hrm-btn-warning"
                                icon={<SaveOutlined />}
                                onClick={handleLuu}
                            >
                                Lưu
                            </Button>
                        )}
                    </Space>
                </Col>
            </Row>

            {/* Thẻ tổng hợp dữ liệu đầu mục (Summary Cards) */}
            <Row gutter={8} className="form-group" style={{ display: 'flex', flexWrap: 'wrap' }}>
                {/* Thẻ 1: Số lao động */}
                <Col style={{ flex: 1, minWidth: '160px' }}>
                    <div className="card card-primary" style={{ padding: '10px' }}>
                        <div className="text-center" style={{ fontSize: '12px' }}>Số lao động</div>
                        <div className="text-bold text-center" style={{ fontSize: '16px' }}>{soLaoDong} người</div>
                    </div>
                </Col>

                {/* Thẻ 2: Tổng tiền được tạm ứng / được nhận */}
                <Col style={{ flex: 1, minWidth: '180px' }}>
                    <div className="card card-primary" style={{ padding: '10px' }}>
                        <div className="text-center" style={{ fontSize: '12px' }}>
                            {isTamUng ? 'Tổng tiền được tạm ứng' : 'Tổng tiền được nhận'}
                        </div>
                        <div className="text-bold text-center" style={{ fontSize: '16px' }}>{formatVND(tongDuocNhan)}</div>
                    </div>
                </Col>

                {/* Các thẻ dành riêng cho Điều chỉnh */}
                {!isTamUng && (
                    <>
                        <Col style={{ flex: 1, minWidth: '180px' }}>
                            <div className="card card-primary" style={{ padding: '10px' }}>
                                <div className="text-center" style={{ fontSize: '12px' }}>Tổng tiền đã tạm ứng</div>
                                <div className="text-bold text-center" style={{ fontSize: '16px' }}>{formatVND(tongDaUng)}</div>
                            </div>
                        </Col>
                        <Col style={{ flex: 1, minWidth: '180px' }}>
                            <div className="card card-primary" style={{ padding: '10px' }}>
                                <div className="text-center" style={{ fontSize: '12px' }}>Tổng tiền còn nhận</div>
                                <div className="text-bold text-center" style={{ fontSize: '16px' }}>{formatVND(tongConDuocNhan)}</div>
                            </div>
                        </Col>
                    </>
                )}

                {/* Thẻ cuối: Trạng thái */}
                <Col style={{ flex: 1, minWidth: '160px' }}>
                    <div className="card card-primary" style={{ padding: '10px' }}>
                        <div className="text-center" style={{ fontSize: '12px' }}>Trạng thái</div>
                        <div className="text-bold text-center" style={{ fontSize: '16px' }}>
                            {isDaDuyet ? (
                                <span style={{ color: '#52c41a' }}>Đã xác nhận</span>
                            ) : (
                                <span style={{ color: '#faad14' }}>Chưa xác nhận</span>
                            )}
                        </div>
                    </div>
                </Col>
            </Row>

            {/* Ghi chú */}
            <Row gutter={8} className="form-group">
                <Col span={24}>
                    <div className="card card-primary" style={{ padding: '15px' }}>
                        <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px' }}>Ghi chú</div>
                        {!isDaDuyet ? (
                            <Input.TextArea
                                rows={3}
                                placeholder="Nhập ghi chú..."
                                value={ghiChu}
                                onChange={(e) => setGhiChu(e.target.value)}
                            />
                        ) : (
                            <div style={{ whiteSpace: 'pre-wrap', minHeight: '40px', background: '#f5f5f5', padding: '10px', borderRadius: '4px' }}>
                                {ghiChu || 'Không có ghi chú'}
                            </div>
                        )}
                    </div>
                </Col>
            </Row>

            {/* Bảng dữ liệu chi tiết */}
            <Row>
                <Col span={24}>
                    <div className="card-outline">
                        <Tabs
                            tabBarExtraContent={
                                <Space>
                                    {coTheDieuChinh && (
                                        <Button
                                            style={{ width: '140px' }}
                                            type="default"
                                            onClick={() => {
                                                if (isEdit) {
                                                    if (changedRowIds.size > 0) {
                                                        layThongTin(idBangLuongPhuCap);
                                                        setChangedRowIds(new Set());
                                                    }
                                                }
                                                setIsEdit(!isEdit);
                                            }}
                                            icon={isEdit ? <LockOutlined style={{ color: 'red' }} /> : <EditOutlined style={{ color: '#007bff' }} />}
                                        >
                                            {isEdit ? 'Khóa' : 'Điều chỉnh'}
                                        </Button>
                                    )}
                                    {isEdit && changedRowIds.size > 0 && (
                                        <Button
                                            className="hrm-btn hrm-btn-warning"
                                            icon={<SaveOutlined />}
                                            onClick={handleLuuDieuChinh}
                                        >
                                            Lưu điều chỉnh ({changedRowIds.size})
                                        </Button>
                                    )}
                                </Space>
                            }
                            defaultActiveKey="1"
                            items={[
                                {
                                    key: '1',
                                    label: isTamUng ? 'Bảng phụ cấp tạm ứng' : 'Bảng phụ cấp điều chỉnh',
                                    children: (
                                        <TableChiTietLuongPhuCap
                                            data={danhSachNLD}
                                            loading={loading}
                                            isEdit={isEdit}
                                            onChangeItem={onChangeItem}
                                            isDieuChinh={!isTamUng}
                                        />
                                    ),
                                },
                            ]}
                        />
                    </div>
                </Col>
            </Row>

            {/* Modal điều chỉnh thông tin đợt phụ cấp */}
            <ModalTextForm
                title="Cập nhật thông tin đợt phụ cấp"
                hideFooter
                show={isShowModalCapNhat}
                handleClose={() => setIsShowModalCapNhat(false)}
            >
                <Form
                    layout="vertical"
                    validateMessages={validateMessages}
                    onFinish={onFinishCapNhat}
                    form={formCapNhat}
                >
                    {isTamUng ? (
                        <Row gutter={12}>
                            <Col span={12}>
                                <Form.Item
                                    label="Số công ăn ca"
                                    name="soCongAnCa"
                                    rules={[{ required: true, message: 'Vui lòng nhập số công ăn ca' }]}
                                >
                                    <InputNumber min={0} max={31} style={{ width: '100%' }} placeholder="Nhập số công ăn ca" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Số công CTP"
                                    name="soCongCTP"
                                    rules={[{ required: true, message: 'Vui lòng nhập số công CTP' }]}
                                >
                                    <InputNumber min={0} max={31} style={{ width: '100%' }} placeholder="Nhập số công CTP" />
                                </Form.Item>
                            </Col>
                        </Row>
                    ) : (
                        <Row gutter={12}>
                            <Col span={10}>
                                <Form.Item label="Năm tạm ứng" name="namTamUng">
                                    <DatePicker
                                        picker="year"
                                        style={{ width: '100%' }}
                                        onChange={(date) => {
                                            const y = date ? date.year() : dayjs().year();
                                            setNamTamUng(y);
                                            fetchDsTamUng(y);
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={14}>
                                <Form.Item
                                    label="Kỳ phụ cấp đã tạm ứng"
                                    name="idLuongTamUng"
                                    rules={[]}
                                >
                                    <Select
                                        placeholder="Chọn kỳ phụ cấp tạm ứng"
                                        allowClear options={dsTamUng.map((x) => ({ value: x.id, label: x.tenKyLuong }))}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    )}
                    <Form.Item>
                        <Button
                            type="primary"
                            className="float-right"
                            htmlType="submit"
                            icon={<SaveOutlined />}
                        >
                            Cập nhật
                        </Button>
                    </Form.Item>
                </Form>
            </ModalTextForm>

            <ModalTextForm
                show={isShowModalDuyet}
                title="Xác nhận bảng phụ cấp"
                handleClose={() => setIsShowModalDuyet(false)}
                handleSave={handleDuyet}
            >
                Bạn có chắc muốn xác nhận bảng phụ cấp{' '}
                {luongPhuCap?.tenKyLuong ?? ''} không?
            </ModalTextForm>

            <ModalTextForm
                show={isShowModalXoa}
                title="Xóa bảng phụ cấp"
                handleClose={() => setIsShowModalXoa(false)}
                handleSave={handleXoa}
            >
                Bạn có chắc chắn muốn xóa bảng phụ cấp <b>{luongPhuCap?.tenKyLuong ?? ''}</b>? Hành động này sẽ xóa toàn bộ dữ liệu chi tiết của bảng phụ cấp.
            </ModalTextForm>
            {/* Modal Import Excel */}
            <Modal
                title="Nhập dữ liệu phụ cấp từ tệp Excel"
                open={isShowImportModal}
                onCancel={() => {
                    setIsShowImportModal(false);
                    setFileUpload(null);
                }}
                footer={[
                    <Button
                        key="back"
                        onClick={() => {
                            setIsShowImportModal(false);
                            setFileUpload(null);
                        }}
                    >
                        Hủy
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        disabled={!fileUpload}
                        icon={<UploadOutlined />}
                        onClick={handleImportExcel}
                    >
                        Tải lên
                    </Button>,
                ]}
                destroyOnClose
                centered
            >
                <div style={{ padding: '8px 0' }}>
                    <Dropzone
                        maxFiles={1}
                        multiple={false}
                        accept={{
                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
                            'application/vnd.ms-excel': ['.xls'],
                        }}
                        onDrop={(acceptedFiles) => {
                            if (acceptedFiles && acceptedFiles.length > 0) {
                                setFileUpload(acceptedFiles[0]);
                            }
                        }}
                    >
                        {({ getRootProps, getInputProps, isDragActive }) => (
                            <div
                                {...getRootProps()}
                                className="hrm-dropzone-uploadfile"
                                style={{
                                    padding: '28px 16px',
                                    background: isDragActive ? '#e6f4ff' : '#fafafa',
                                    borderColor: isDragActive ? '#1677ff' : fileUpload ? '#28a745' : '#d9d9d9',
                                    borderWidth: 1,
                                    borderStyle: 'dashed',
                                    borderRadius: 8,
                                    textAlign: 'center',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                }}
                            >
                                <input {...getInputProps()} />
                                {isDragActive ? (
                                    <div>
                                        <p style={{ marginBottom: 8 }}>
                                            <InboxOutlined style={{ color: '#1677ff', fontSize: 42 }} />
                                        </p>
                                        <p style={{ fontSize: 14, fontWeight: 500, color: '#1677ff', margin: 0 }}>
                                            Thả tệp Excel vào đây...
                                        </p>
                                    </div>
                                ) : fileUpload ? (
                                    <div>
                                        <p style={{ marginBottom: 8 }}>
                                            <FileExcelOutlined style={{ color: '#217346', fontSize: 40 }} />
                                        </p>
                                        <p style={{ fontSize: 14, fontWeight: 600, color: '#262626', margin: '0 0 4px 0', wordBreak: 'break-all' }}>
                                            {fileUpload.name}
                                        </p>
                                        <p style={{ fontSize: 12, color: '#8c8c8c', margin: '0 0 8px 0' }}>
                                            Kích thước: {(fileUpload.size / 1024).toFixed(1)} KB
                                        </p>
                                        <Button
                                            size="small"
                                            danger
                                            icon={<DeleteOutlined />}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setFileUpload(null);
                                            }}
                                        >
                                            Chọn tệp khác
                                        </Button>
                                    </div>
                                ) : (
                                    <div>
                                        <p style={{ marginBottom: 8 }}>
                                            <InboxOutlined style={{ color: '#1677ff', fontSize: 42 }} />
                                        </p>
                                        <p style={{ fontSize: 14, fontWeight: 500, color: '#262626', margin: '0 0 4px 0' }}>
                                            Nhấp hoặc kéo thả tệp Excel vào đây để tải lên
                                        </p>
                                        <p style={{ fontSize: 12, color: '#8c8c8c', margin: 0 }}>
                                            Hỗ trợ định dạng tệp .xlsx, .xls
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}
                    </Dropzone>
                </div>
            </Modal>
        </section>
    );
};

export default ChiTietLuongPhuCap;
